/**
 * Utility to convert a value to a number, returning NaN for non-string, empty, or whitespace-only strings
 * @param value - The value to convert
 * @returns The converted number or NaN
 */
export const valueToNumber = (value: unknown) => {
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value !== 'string') {
        return Number.NaN;
    }
    const trimmedValue = value.trim();
    if (trimmedValue === '') {
        return Number.NaN;
    }
    return Number(trimmedValue);
};
